import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class PurchaseDetailsCheckoutUseCase extends UseCase {
  constructor({repository, getCurrentUserService, purchaseDetailsCheckoutError}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._purchaseDetailsCheckoutError = purchaseDetailsCheckoutError
  }

  _throwPurchaseDetailsCheckoutError(message) {
    throw this._purchaseDetailsCheckoutError(`[PurchaseDetailsCheckoutErrorsRepository#get] ${message}`)
  }

  _getCurrentUser = async () => this._getCurrentUserService.execute()

  _getUserId = async () => {
    const currentUser = await this._getCurrentUser()
    return currentUser ? currentUser.getId() : this._throwPurchaseDetailsCheckoutError('Unknown user ID')
  }

  /**
   * @return {Promise<Object, Error>}
   */
  async execute({data, paymentId}) {
    const userId = await this._getUserId()
    const purchaseDetailsResponse = await this._repository.getPurchaseDetails({
      data,
      paymentId,
      userId
    })
    return purchaseDetailsResponse.toJSON()
  }
}
